let templateString = require('./not-control-logo.html');

let skControlLogoController = function(
  sweet,
  DateManipulationService,
  ReportingService,
  // SessionsService,
  ToastsService
) {
  let ctrl = this;
  ctrl.managingOrgId = 'ducky'

  ctrl.generateDisplayReport = () => {
    return ReportingService.deviceReportUrl({managingOrgId:ctrl.managingOrgId});
};

  ctrl.generateManagingOrgDisplayReport = function () {
    let data = {
      'managingOrgId': ctrl.managingOrgId,
      'startDate': DateManipulationService.formatIsoDatetime(new Date()),
      'endDate': DateManipulationService.formatIsoDatetime(new Date())
    };
    return ReportingService.generateManagingOrgDisplayReport(data)
      .then(() => {
        ToastsService.showSuccessToast('Device report queued. Please check the report list');
      }, () => {
        return sweet.show('Oops...', 'There was a problem queueing the report.', 'error');
      });
  };

  ctrl.$onChanges = changes => {
    if (changes.managingOrgId) {
      ctrl.managingOrgId = changes.managingOrgId.currentValue;
    }
    if (changes.isManagingOrgAdmin) {
      ctrl.isManagingOrgAdmin = changes.isManagingOrgAdmin.currentValue
    }
    
  };
  ctrl.$onInit = () => {
    console.log('$onInit')

  };

}

export let skNotControlLogo = {
  template: templateString,
  bindings: {
    managingOrgId: '<',
    isManagingOrgAdmin: '<'
  },
  controller: skControlLogoController
};

angular.module('skykitProvisioning')
.component('skNotControlLogo', skNotControlLogo)
.controller('skControlLogoController', skControlLogoController)